var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam-box", attrs: { cytag: "exam-item" } }, [
    _c(
      "div",
      {
        class:
          "d-flex p-2 exam-test " +
          (_vm.onlyAction ? "justify-center" : "justify-space-between") +
          " " +
          (_vm.currentUserExam.isWaitingScoreCheck ? "disabled" : ""),
        on: {
          click: function ($event) {
            return _vm.goToUserExamHistory(
              _vm.latestHistory.exam,
              _vm.currentUserExam
            )
          },
        },
      },
      [
        !_vm.onlyAction
          ? _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("v-img", {
                  attrs: {
                    width: _vm.isMobile ? 40 : 70,
                    height: _vm.isMobile ? 40 : 70,
                    src:
                      _vm.latestHistory.exam.image &&
                      _vm.latestHistory.exam.image.url
                        ? _vm.latestHistory.exam.image.url
                        : _vm.latestHistory.exam.examImageUrl,
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ms-3" },
                  [
                    !_vm.isNoHistory
                      ? _c("div", { staticClass: "gray-format" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.latestHistory.title) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex" }, [
                      _c("div", { staticClass: "exam-title" }, [
                        _vm._v(_vm._s(_vm.oldestHistory.exam.name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.currentUserExam.startedAt
                      ? _c("div", { staticClass: "gray-format" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.dateFormat(_vm.currentUserExam.startedAt)
                              ) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowResult &&
                    !_vm.latestHistory.exam.isForUser &&
                    !_vm.latestHistory.exam.canRetest
                      ? [
                          _c("p", { staticClass: "caption" }, [
                            _c("span", { staticClass: "ranking me-2" }, [
                              _vm._v(
                                "\n              ランキング " +
                                  _vm._s(_vm.currentUserExam.position) +
                                  " 位 / " +
                                  _vm._s(_vm.exam.usersCount) +
                                  " 人中\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "ranking me-2" }, [
                              _vm._v(
                                "平均 " +
                                  _vm._s(_vm.latestHistory.exam.averageRate) +
                                  "%"
                              ),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex" }, [
          _c(
            "div",
            [
              _vm.latestHistory.exam.isDone(_vm.currentUserExam) &&
              _vm.latestHistory.exam.hideResult
                ? _c(
                    "div",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: !_vm.isMobile,
                            "x-small": _vm.isMobile,
                            rounded: "",
                            color: "warning",
                            dark: "",
                          },
                        },
                        [_vm._v(" 結果公開待ち")]
                      ),
                    ],
                    1
                  )
                : _vm.latestHistory.exam.isDone(_vm.currentUserExam) &&
                  _vm.currentUserExam.isWaitingScoreCheck
                ? _c(
                    "div",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: !_vm.isMobile,
                            "x-small": _vm.isMobile,
                            rounded: "",
                            color: "warning",
                            dark: "",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("exam_result.check_score")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm.latestHistory.exam.isDone(_vm.currentUserExam)
                ? _c(
                    "div",
                    {
                      staticClass: "exam-done",
                      class: _vm.onlyAction
                        ? "align-items-center"
                        : "align-items-end",
                    },
                    [
                      _c("ProgressRotate", {
                        attrs: {
                          score: _vm.currentUserExam.average,
                          value: _vm.currentUserExam.average,
                          color: !_vm.currentUserExam.passed
                            ? "red"
                            : "#7dd420",
                          width: 3,
                          size: 60,
                          rotate: -90,
                        },
                      }),
                      _vm._v(" "),
                      _vm.exam.canRetest
                        ? _c(
                            "v-menu",
                            {
                              attrs: { "offset-y": "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  color: "black",
                                                  dark: "",
                                                  cytag: "retest-menu",
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              "\n                再テストなど 🔽\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1049067543
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("v-list", [
                                _c(
                                  "div",
                                  { staticClass: "retest-menu" },
                                  [
                                    _vm.schoolSetting.useExamStock
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass: "mt-3",
                                            attrs: {
                                              rounded: "",
                                              color: "warning",
                                              dark: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                _vm.reTest(
                                                  _vm.latestHistory.exam,
                                                  _vm.TYPE_USE_NIGATE_EXAM.toString()
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("ニガテ問題を再テスト")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.schoolSetting.useExamStock
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass: "mt-3",
                                            attrs: {
                                              rounded: "",
                                              color: "warning",
                                              dark: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                _vm.reTest(
                                                  _vm.exam,
                                                  _vm.TYPE_USE_SPECIAL_EXAM.toString()
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("別の問題で再テスト")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "mt-3",
                                        attrs: {
                                          rounded: "",
                                          color: "warning",
                                          dark: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            _vm.reTest(
                                              _vm.latestHistory.exam,
                                              _vm.TYPE_USE_EXAM_FROM_FAILED.toString()
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("前回マチガイ再テスト")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "mt-3",
                                        attrs: {
                                          rounded: "",
                                          color: "warning",
                                          dark: "",
                                          cytag: "retest",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.reTest(_vm.exam)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  再テスト\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.onShowHistories
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass: "mt-3",
                                            attrs: {
                                              rounded: "",
                                              color: "warning",
                                              dark: "",
                                              cytag: "showHistories",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return function () {
                                                  _vm.onShowHistories(_vm.exam)
                                                }.apply(null, arguments)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                今までのテスト結果を見る\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.oldestHistory.userExam.id !=
                                    _vm.currentUserExam.id
                                      ? _c("DialogDeleteExamConfirm", {
                                          attrs: {
                                            title:
                                              "本当にテストを削除しますか？",
                                          },
                                          on: {
                                            confirmed: function ($event) {
                                              return _vm.confimClearHistoryTest(
                                                _vm.currentUserExam
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: {
                        rounded: "",
                        color: _vm.latestHistory.exam.isTestTimeOver(
                          _vm.currentUserExam
                        )
                          ? "red"
                          : "primary",
                        dark: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.gotoExam(
                            _vm.latestHistory.exam,
                            _vm.currentUserExam
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.btnName(
                            _vm.latestHistory.exam,
                            _vm.currentUserExam
                          )
                        )
                      ),
                    ]
                  ),
            ],
            1
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.exam.canRetest && !_vm.isNoHistory && !_vm.onShowHistories
      ? _c(
          "div",
          { class: [!_vm.isMobile ? "" : "", "mb-3"] },
          _vm._l(_vm.showingHistories, function (history) {
            return _c(
              "div",
              { key: history.userExam.id },
              [
                _c("v-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "py-1 px-2 d-flex justify-space-between exam-test align-center",
                    on: {
                      click: function ($event) {
                        return _vm.goToUserExamHistory(
                          history.exam,
                          history.userExam
                        )
                      },
                    },
                  },
                  [
                    _c("div", [
                      _c("div", { staticClass: "me-5 exam-title text-blue" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(history.title) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      history.userExam.startedAt
                        ? _c("div", { staticClass: "gray-format" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.dateFormat(history.userExam.startedAt)
                                ) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex align-center" },
                      [
                        history.exam.isDone(history.userExam)
                          ? _c("div", { staticClass: "average-score" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(history.userExam.average) +
                                  "%\n          "
                              ),
                            ])
                          : _c(
                              "div",
                              { staticClass: "me-5" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      rounded: "",
                                      color: history.exam.isTestTimeOver(
                                        history.userExam
                                      )
                                        ? "red"
                                        : "primary",
                                      dark: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.gotoExam(
                                          history.exam,
                                          history.userExam
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(history.btnName))]
                                ),
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _vm.oldestHistory.userExam.id != history.userExam.id
                          ? _c("DialogDeleteConfirm", {
                              attrs: { title: "本当にテストを削除しますか？" },
                              on: {
                                confirmed: function ($event) {
                                  return _vm.confimClearHistoryTest(
                                    history.userExam
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }